import React from "react";
import Heading from "components/common/Heading";
interface Props {
  title?: string;
  headerWidget?: React.ReactNode;
  children: React.ReactNode;
  displayHeader?: boolean;
  headerMargin?: string;
  hideHeaderOnSmallScreen?: boolean;
  displaySecondaryHeaderOnSmallScreen?: boolean;
  titleForSmallScreen?: string;
  widgetInNewLineForSmallScreen?: boolean;
}

export default function WidgetPanel(props: Props) {
  const SecondaryHeadingForSmallScreen = () => {
    return (
      <div className="mb-4 inline-block lg:hidden w-full font-semibold text-sm text-promGray2">
        {props.title}
      </div>
    );
  };

  const PrimaryHeading = () => {
    const getHeading = (title: string, forSmallScreen: boolean = false) => {
      return (
        <Heading
          text={title}
          fontClass={forSmallScreen ? "font-semibold text-base" : ""}
        />
      );
    };

    return (
      <div className="flex-shrink-0">
        <div className="inline-block lg:hidden">
          {getHeading(props.titleForSmallScreen || props.title || "", true)}
        </div>
        <div className="hidden lg:inline-block">
          {getHeading(props.title || "")}
        </div>
      </div>
    );
  };

  return (
    <div className="h-full">
      {props.displaySecondaryHeaderOnSmallScreen ? (
        <SecondaryHeadingForSmallScreen />
      ) : (
        ""
      )}
      <div className="py-4 lg:py-6 px-4 lg:px-10 shadow rounded bg-white h-full">
        {props.displayHeader !== false && (
          <div
            className={`${
              props.hideHeaderOnSmallScreen ? "hidden lg:flex" : "flex"
            } ${
              props.widgetInNewLineForSmallScreen ? "flex-col lg:flex-row" : ""
            } ${props.headerMargin ?? "mb-6"}`}
          >
            <PrimaryHeading />
            <div
              className={`flex flex-grow ${
                props.widgetInNewLineForSmallScreen
                  ? "lg:justify-end mt-6 lg:mt-0"
                  : "justify-end"
              }`}
            >
              {props.headerWidget}
            </div>
          </div>
        )}
        <div>{props.children}</div>
      </div>
    </div>
  );
}
